( function () {
	const sections = document.querySelectorAll( '.wp-block-milestonevideo-theme-realizacje' );
	if ( ! sections.length ) return;

	/* ---------- reveal on scroll (1:1 z exportu — próg top < 90% viewportu) ---------- */
	const reveals = document.querySelectorAll(
		'.wp-block-milestonevideo-theme-realizacje .reveal:not(.in)'
	);
	const reduceMotion = window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;

	if ( reveals.length ) {
		if ( reduceMotion || ! ( 'IntersectionObserver' in window ) ) {
			reveals.forEach( ( el ) => el.classList.add( 'in' ) );
		} else {
			const io = new IntersectionObserver(
				( entries ) => {
					entries.forEach( ( entry ) => {
						if ( entry.isIntersecting ) {
							entry.target.classList.add( 'in' );
							io.unobserve( entry.target );
						}
					} );
				},
				{ threshold: 0, rootMargin: '0px 0px -10% 0px' } // top < 90% viewportu ~ rootMargin -10%
			);
			reveals.forEach( ( el ) => io.observe( el ) );
		}
	}

	/* ---------- lightbox ---------- */
	let lightbox = null;
	let lastFocused = null;

	function closeLightbox() {
		if ( ! lightbox ) return;
		lightbox.remove();
		lightbox = null;
		document.body.style.overflow = '';
		if ( lastFocused && typeof lastFocused.focus === 'function' ) {
			lastFocused.focus();
		}
	}

	function openLightbox( data ) {
		lastFocused = document.activeElement;

		const wrap = document.createElement( 'div' );
		wrap.className = 'work__lightbox';

		const inner = document.createElement( 'div' );
		inner.className = 'work__lightbox-inner';

		const head = document.createElement( 'div' );
		head.className = 'work__lightbox-head';

		const title = document.createElement( 'span' );
		title.className = 'work__lightbox-title';
		title.textContent = data.title;

		if ( data.tag ) {
			const tag = document.createElement( 'span' );
			tag.className = 'work__lightbox-tag';
			tag.textContent = data.tag;
			title.appendChild( document.createTextNode( ' ' ) );
			title.appendChild( tag );
		}

		const close = document.createElement( 'button' );
		close.type = 'button';
		close.className = 'work__lightbox-close';
		close.setAttribute( 'aria-label', 'Zamknij' );
		close.textContent = '✕';
		close.addEventListener( 'click', closeLightbox );

		head.appendChild( title );
		head.appendChild( close );

		const frameWrap = document.createElement( 'div' );
		frameWrap.className = 'work__lightbox-frame';

		const iframe = document.createElement( 'iframe' );
		iframe.src =
			'https://www.youtube.com/embed/' +
			encodeURIComponent( data.ytId ) +
			'?autoplay=1&rel=0&modestbranding=1&playsinline=1';
		iframe.title = data.title;
		iframe.setAttribute( 'frameborder', '0' );
		iframe.setAttribute(
			'allow',
			'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
		);
		iframe.setAttribute( 'referrerpolicy', 'strict-origin-when-cross-origin' );
		iframe.setAttribute( 'allowfullscreen', '' );

		frameWrap.appendChild( iframe );
		inner.appendChild( head );
		inner.appendChild( frameWrap );
		wrap.appendChild( inner );

		wrap.addEventListener( 'click', ( e ) => {
			if ( e.target === wrap ) closeLightbox();
		} );

		document.body.appendChild( wrap );
		document.body.style.overflow = 'hidden';
		lightbox = wrap;
		close.focus();
	}

	document.addEventListener( 'keydown', ( e ) => {
		if ( e.key === 'Escape' && lightbox ) closeLightbox();
	} );

	sections.forEach( ( section ) => {
		section.querySelectorAll( '.work__card' ).forEach( ( card ) => {
			const ytId = card.dataset.ytid;
			if ( ! ytId ) return;
			card.addEventListener( 'click', () => {
				openLightbox( {
					title: card.dataset.title || '',
					tag: card.dataset.tag || '',
					ytId,
				} );
			} );
		} );
	} );
} )();
